import React, { useState, useEffect } from 'react'
import { ProjectWithComments } from '../../../../types/project'
import { useRequests } from '../../../../requests/useRequests'
import { RefreshActions } from '../../../../state/refresh'
import { useDispatch } from 'react-redux'

interface ProjectNameEditorProps {
  project: ProjectWithComments
}

const ProjectNameEditor: React.FC<ProjectNameEditorProps> = ({
  project
}) => {
  const requestMaker = useRequests()
  const dispatch = useDispatch()
  const [editedName, setEditedName] = useState(project.name)
  const [isEditing, setIsEditing] = useState(false)
  const [projectName, setProjectName] = useState(project.name)

  useEffect(() => {
    setEditedName(project.name)
  }, [project.name])

  const handleSave = () => {
    setProjectName(editedName)
    updateProjectName(editedName)
  }

  const handleCancel = () => {
    setEditedName(project.name)
    setIsEditing(false)
  }

  const updateProjectName = async (name: string) => {
    if (!project.id || !name.trim()) return false
    try {
      await requestMaker.updateProject(project.id, { name })
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Nazwa projektu została zaktualizowana'
        })
      )
      return true
    } catch (error) {
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Nie udało się zaktualizować nazwy projektu'
        })
      )
      return false
    }
  }

  return (
    <div className='row mb-30'>
      <div className='col-sm-12'>
        <div className='d-flex justify-content-between align-items-center flex-wrap'>
          <div className='d-flex align-items-center mb-3 mb-md-0'>
            {isEditing
              ? (
                <div className='tw-flex tw-gap-x-2 tw-h-fit'>
                  <input
                    type='text'
                    className='form-control mr-10'
                    value={editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                  />
                  <button
                    className={`
                                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-red-500 hover:tw-bg-opacity-90 focus:tw-bg-red-500
                                    `}
                    onClick={handleCancel}
                  >
                    Anuluj
                  </button>
                  <button
                    className={`
                                      tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                    `}
                    onClick={handleSave}
                  >
                    Zapisz
                  </button>
                </div>
                )
              : (
                <h3 className='mb-0 tw-font-bold'>{projectName ?? project.name}</h3>
                )}

            {!isEditing && (
              <button
                className='tw-ml-4 tw-text-blue-500 hover:tw-text-blue-700'
                onClick={() => setIsEditing(true)}
              >
                <i className='fa fa-edit' />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectNameEditor
